import { render, staticRenderFns } from "./ViewHeadline.vue?vue&type=template&id=40160c22&"
import script from "./ViewHeadline.vue?vue&type=script&lang=js&"
export * from "./ViewHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports